import { render, staticRenderFns } from "./systemMessages.vue?vue&type=template&id=5c3bcc6e&scoped=true"
import script from "./systemMessages.vue?vue&type=script&lang=js"
export * from "./systemMessages.vue?vue&type=script&lang=js"
import style0 from "./systemMessages.vue?vue&type=style&index=0&id=5c3bcc6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3bcc6e",
  null
  
)

export default component.exports